export default __webpack_public_path__ + "static/media/1.4ff5b1ac.jpg";